// Lib
import React, { useState } from 'react'

// Include in project
import styles from './index.module.scss'
import { s3URL } from 'configs'

interface Props {
  img?: string
  name?: string
  readonly?: boolean
}

const FALLBACK_IMAGE = 'https://eu.ui-avatars.com/api/?name=KP&size=250'

const ImageTable: React.FC<Props> = ({ img }: Props): JSX.Element => {
  const [hasError, setHasError] = useState(false)

  const srcImage = () => {
    if (!img || hasError) return FALLBACK_IMAGE

    return img.startsWith('http') ? img : `${s3URL}/${img}`
  }

  return (
    <div className={styles.container}>
      <img src={srcImage()} alt="" onError={() => setHasError(true)} />
    </div>
  )
}

export default ImageTable
